export default __webpack_public_path__ + "eae6b93b8e695ec314bf8486db42dd41.png";